export default __webpack_public_path__ + "static/media/circle_shape.fca952ba.svg";